import { createContext, useState } from 'react';

import { Profile } from '@app/api/models';

export type ProfileState = {
  profile: Profile | null;
  setProfile: (profile: Profile | null) => void;
};

export const ProfileContext = createContext<ProfileState>({
  profile: null,
  setProfile: (profile: Profile | null) => {},
});

export const ProfileContextProvider = ({ children }) => {
  const [profile, setProfile] = useState<Profile | null>(null);

  return (
    <ProfileContext.Provider value={{ profile, setProfile }}>
      {children}
    </ProfileContext.Provider>
  );
};